module.exports = {
  propertyPaths: {
    propertiesAll: () => '/properties',
    propertyFilter: () => '/properties/:filter',
    shares: () => '/properties/shares',
    loans: () => '/properties/loans',
    faq: () => '/property-page-faq',
  },
};
